/* Progressive decoration only: content and shopping remain available without JS. */
(() => {
  if (matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
  const observer = new IntersectionObserver(entries => entries.forEach(entry => {
    if (entry.isIntersecting) { entry.target.classList.add('ron-visible'); observer.unobserve(entry.target); }
  }), { threshold: 0.08 });
  const watch = root => root.querySelectorAll('.ron-collection-row, .ron-values > div, .ron-story-copy').forEach(el => observer.observe(el));
  watch(document);
  document.addEventListener('shopify:section:load', event => watch(event.target));
})();
(() => {
  const menus = '.ron-category-menu, .ron-mobile-nav';
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const open = [...document.querySelectorAll(menus)].filter(el => el.open);
    if (!open.length) return;
    const active = open.find(el => el.contains(document.activeElement)) || open[0];
    open.forEach(el => { el.open = false; });
    active.querySelector('summary')?.focus();
  });
  document.addEventListener('click', event => {
    document.querySelectorAll(menus).forEach(el => { if (!el.contains(event.target)) el.open = false; });
  });
})();
